"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GIFT_SET_PRODUCT_OPTIONS_FAILED = exports.GIFT_SET_PRODUCT_OPTIONS_SUCCESS = exports.GIFT_SET_PRODUCT_OPTIONS_REQUEST = exports.GIFT_VERIFY_AVAILABLE_CONTACT_RESET = exports.GIFT_VERIFY_AVAILABLE_CONTACT_FAILED = exports.GIFT_VERIFY_AVAILABLE_CONTACT_SUCCESS = exports.GIFT_VERIFY_AVAILABLE_CONTACT_REQUEST = exports.GIFT_SALES_INTEGRATIONS_RESET = exports.GIFT_CANCEL_FAIL = exports.GIFT_CANCEL_SUCCESS = exports.GIFT_CANCEL_REQUEST = exports.GIFT_EXPIRE_FAIL = exports.GIFT_EXPIRE_SUCCESS = exports.GIFT_EXPIRE_REQUEST = exports.SAVE_GIFT_VIDEO_MESSAGE_CLEAN_ERROR = exports.SET_FULL_RESEARCH = exports.WAIT_FOR_INSTANT_RESEARCH = exports.GIFT_SET_VIDEO_MESSAGE_FAIL = exports.GIFT_SET_VIDEO_MESSAGE_SUCCESS = exports.GIFT_SET_VIDEO_MESSAGE_REQUEST = exports.GIFT_SET_SEND_AS_FAIL = exports.GIFT_SET_SEND_AS_SUCCESS = exports.GIFT_SET_SEND_AS_REQUEST = exports.GIFT_SET_GIFT_ACTIONS_FAIL = exports.GIFT_SET_GIFT_ACTIONS_SUCCESS = exports.GIFT_SET_GIFT_ACTIONS_REQUEST = exports.GIFT_DISCARD_FAIL = exports.GIFT_DISCARD_SUCCESS = exports.GIFT_DISCARD_REQUEST = exports.GIFT_CREATE_CLEAR_ERROR = exports.GIFT_CREATE_EDIT_STEP = exports.GIFT_CREATE_EDIT_MESSAGE_FAIL = exports.GIFT_CREATE_EDIT_MESSAGE_SUCCESS = exports.GIFT_CREATE_EDIT_MESSAGE_REQUEST = exports.GIFT_CREATE_SEND_RESET = exports.GIFT_CREATE_SEND_FAIL = exports.GIFT_CREATE_SEND_SUCCESS = exports.GIFT_CREATE_SEND_REQUEST = exports.GIFT_CREATE_SELECT_TEMPLATE = exports.GIFT_CREATE_SELECT_EXCHANGE_PRODUCT = exports.GIFT_SET_PRODUCT_FAIL = exports.GIFT_SET_PRODUCT_SUCCESS = exports.GIFT_CREATE_SELECT_PRODUCT = exports.GIFT_REFRESH_LOAD_FAIL = exports.GIFT_REFRESH_LOAD_SUCCESS = exports.GIFT_REFRESH_LOAD_REQUEST = exports.GIFT_CREATE_LOAD_FAIL = exports.GIFT_CREATE_LOAD_SUCCESS = exports.GIFT_CREATE_LOAD_REQUEST = exports.GIFT_CREATE_RESET = exports.GIFT_CREATE_FAIL = exports.GIFT_CREATE_SUCCESS = exports.GIFT_CREATE_REQUEST = void 0;
var GIFT_CREATE_REQUEST = 'GIFT_CREATE_REQUEST';
exports.GIFT_CREATE_REQUEST = GIFT_CREATE_REQUEST;
var GIFT_CREATE_SUCCESS = 'GIFT_CREATE_SUCCESS';
exports.GIFT_CREATE_SUCCESS = GIFT_CREATE_SUCCESS;
var GIFT_CREATE_FAIL = 'GIFT_CREATE_FAIL';
exports.GIFT_CREATE_FAIL = GIFT_CREATE_FAIL;
var GIFT_CREATE_RESET = 'GIFT_CREATE_RESET';
exports.GIFT_CREATE_RESET = GIFT_CREATE_RESET;
var GIFT_CREATE_LOAD_REQUEST = 'GIFT_CREATE_LOAD_REQUEST';
exports.GIFT_CREATE_LOAD_REQUEST = GIFT_CREATE_LOAD_REQUEST;
var GIFT_CREATE_LOAD_SUCCESS = 'GIFT_CREATE_LOAD_SUCCESS';
exports.GIFT_CREATE_LOAD_SUCCESS = GIFT_CREATE_LOAD_SUCCESS;
var GIFT_CREATE_LOAD_FAIL = 'GIFT_CREATE_LOAD_FAIL';
exports.GIFT_CREATE_LOAD_FAIL = GIFT_CREATE_LOAD_FAIL;
var GIFT_REFRESH_LOAD_REQUEST = 'GIFT_REFRESH_LOAD_REQUEST';
exports.GIFT_REFRESH_LOAD_REQUEST = GIFT_REFRESH_LOAD_REQUEST;
var GIFT_REFRESH_LOAD_SUCCESS = 'GIFT_REFRESH_LOAD_SUCCESS';
exports.GIFT_REFRESH_LOAD_SUCCESS = GIFT_REFRESH_LOAD_SUCCESS;
var GIFT_REFRESH_LOAD_FAIL = 'GIFT_REFRESH_LOAD_FAIL';
exports.GIFT_REFRESH_LOAD_FAIL = GIFT_REFRESH_LOAD_FAIL;
var GIFT_CREATE_SELECT_PRODUCT = 'GIFT_CREATE_SELECT_PRODUCT';
exports.GIFT_CREATE_SELECT_PRODUCT = GIFT_CREATE_SELECT_PRODUCT;
var GIFT_SET_PRODUCT_SUCCESS = 'GIFT_SET_PRODUCT_SUCCESS';
exports.GIFT_SET_PRODUCT_SUCCESS = GIFT_SET_PRODUCT_SUCCESS;
var GIFT_SET_PRODUCT_FAIL = 'GIFT_SET_PRODUCT_FAIL';
exports.GIFT_SET_PRODUCT_FAIL = GIFT_SET_PRODUCT_FAIL;
var GIFT_CREATE_SELECT_EXCHANGE_PRODUCT = 'GIFT_CREATE_SELECT_EXCHANGE_PRODUCT';
exports.GIFT_CREATE_SELECT_EXCHANGE_PRODUCT = GIFT_CREATE_SELECT_EXCHANGE_PRODUCT;
var GIFT_CREATE_SELECT_TEMPLATE = 'GIFT_CREATE_SELECT_TEMPLATE';
exports.GIFT_CREATE_SELECT_TEMPLATE = GIFT_CREATE_SELECT_TEMPLATE;
var GIFT_CREATE_SEND_REQUEST = 'GIFT_CREATE_SEND_REQUEST';
exports.GIFT_CREATE_SEND_REQUEST = GIFT_CREATE_SEND_REQUEST;
var GIFT_CREATE_SEND_SUCCESS = 'GIFT_CREATE_SEND_SUCCESS';
exports.GIFT_CREATE_SEND_SUCCESS = GIFT_CREATE_SEND_SUCCESS;
var GIFT_CREATE_SEND_FAIL = 'GIFT_CREATE_SEND_FAIL';
exports.GIFT_CREATE_SEND_FAIL = GIFT_CREATE_SEND_FAIL;
var GIFT_CREATE_SEND_RESET = 'GIFT_CREATE_SEND_RESET';
exports.GIFT_CREATE_SEND_RESET = GIFT_CREATE_SEND_RESET;
var GIFT_CREATE_EDIT_MESSAGE_REQUEST = 'GIFT_CREATE_EDIT_MESSAGE_REQUEST';
exports.GIFT_CREATE_EDIT_MESSAGE_REQUEST = GIFT_CREATE_EDIT_MESSAGE_REQUEST;
var GIFT_CREATE_EDIT_MESSAGE_SUCCESS = 'GIFT_CREATE_EDIT_MESSAGE_SUCCESS';
exports.GIFT_CREATE_EDIT_MESSAGE_SUCCESS = GIFT_CREATE_EDIT_MESSAGE_SUCCESS;
var GIFT_CREATE_EDIT_MESSAGE_FAIL = 'GIFT_CREATE_EDIT_MESSAGE_FAIL';
exports.GIFT_CREATE_EDIT_MESSAGE_FAIL = GIFT_CREATE_EDIT_MESSAGE_FAIL;
var GIFT_CREATE_EDIT_STEP = 'GIFT_CREATE_EDIT_STEP';
exports.GIFT_CREATE_EDIT_STEP = GIFT_CREATE_EDIT_STEP;
var GIFT_CREATE_CLEAR_ERROR = 'GIFT_CREATE_CLEAR_ERROR';
exports.GIFT_CREATE_CLEAR_ERROR = GIFT_CREATE_CLEAR_ERROR;
var GIFT_DISCARD_REQUEST = 'GIFT_DISCARD_REQUEST';
exports.GIFT_DISCARD_REQUEST = GIFT_DISCARD_REQUEST;
var GIFT_DISCARD_SUCCESS = 'GIFT_DISCARD_SUCCESS';
exports.GIFT_DISCARD_SUCCESS = GIFT_DISCARD_SUCCESS;
var GIFT_DISCARD_FAIL = 'GIFT_DISCARD_FAIL';
exports.GIFT_DISCARD_FAIL = GIFT_DISCARD_FAIL;
var GIFT_SET_GIFT_ACTIONS_REQUEST = 'GIFT_SET_GIFT_ACTIONS_REQUEST';
exports.GIFT_SET_GIFT_ACTIONS_REQUEST = GIFT_SET_GIFT_ACTIONS_REQUEST;
var GIFT_SET_GIFT_ACTIONS_SUCCESS = 'GIFT_SET_GIFT_ACTIONS_SUCCESS';
exports.GIFT_SET_GIFT_ACTIONS_SUCCESS = GIFT_SET_GIFT_ACTIONS_SUCCESS;
var GIFT_SET_GIFT_ACTIONS_FAIL = 'GIFT_SET_GIFT_ACTIONS_FAIL';
exports.GIFT_SET_GIFT_ACTIONS_FAIL = GIFT_SET_GIFT_ACTIONS_FAIL;
var GIFT_SET_SEND_AS_REQUEST = 'GIFT_SET_SEND_AS_REQUEST';
exports.GIFT_SET_SEND_AS_REQUEST = GIFT_SET_SEND_AS_REQUEST;
var GIFT_SET_SEND_AS_SUCCESS = 'GIFT_SET_SEND_AS_SUCCESS';
exports.GIFT_SET_SEND_AS_SUCCESS = GIFT_SET_SEND_AS_SUCCESS;
var GIFT_SET_SEND_AS_FAIL = 'GIFT_SET_SEND_AS_FAIL';
exports.GIFT_SET_SEND_AS_FAIL = GIFT_SET_SEND_AS_FAIL;
var GIFT_SET_VIDEO_MESSAGE_REQUEST = 'GIFT_SET_VIDEO_MESSAGE_REQUEST';
exports.GIFT_SET_VIDEO_MESSAGE_REQUEST = GIFT_SET_VIDEO_MESSAGE_REQUEST;
var GIFT_SET_VIDEO_MESSAGE_SUCCESS = 'GIFT_SET_VIDEO_MESSAGE_SUCCESS';
exports.GIFT_SET_VIDEO_MESSAGE_SUCCESS = GIFT_SET_VIDEO_MESSAGE_SUCCESS;
var GIFT_SET_VIDEO_MESSAGE_FAIL = 'GIFT_SET_VIDEO_MESSAGE_FAIL';
exports.GIFT_SET_VIDEO_MESSAGE_FAIL = GIFT_SET_VIDEO_MESSAGE_FAIL;
var WAIT_FOR_INSTANT_RESEARCH = {
  START: 'CREATE_GIFT@WAIT_FOR_INSTANT_RESEARCH/START',
  COMPLETE: 'CREATE_GIFT@WAIT_FOR_INSTANT_RESEARCH/COMPLETE',
  CANCEL: 'CREATE_GIFT@WAIT_FOR_INSTANT_RESEARCH/CANCEL'
};
exports.WAIT_FOR_INSTANT_RESEARCH = WAIT_FOR_INSTANT_RESEARCH;
var SET_FULL_RESEARCH = {
  REQUEST: 'CREATE_GIFT@SET_FULL_RESEARCH/REQUEST',
  SUCCESS: 'CREATE_GIFT@SET_FULL_RESEARCH/SUCCESS',
  FAIL: 'CREATE_GIFT@SET_FULL_RESEARCH/FAIL'
};
exports.SET_FULL_RESEARCH = SET_FULL_RESEARCH;
var SAVE_GIFT_VIDEO_MESSAGE_CLEAN_ERROR = 'SAVE_GIFT_VIDEO_MESSAGE_CLEAN_ERROR';
exports.SAVE_GIFT_VIDEO_MESSAGE_CLEAN_ERROR = SAVE_GIFT_VIDEO_MESSAGE_CLEAN_ERROR;
var GIFT_EXPIRE_REQUEST = 'GIFT_EXPIRE_REQUEST';
exports.GIFT_EXPIRE_REQUEST = GIFT_EXPIRE_REQUEST;
var GIFT_EXPIRE_SUCCESS = 'GIFT_EXPIRE_SUCCESS';
exports.GIFT_EXPIRE_SUCCESS = GIFT_EXPIRE_SUCCESS;
var GIFT_EXPIRE_FAIL = 'GIFT_EXPIRE_FAIL';
exports.GIFT_EXPIRE_FAIL = GIFT_EXPIRE_FAIL;
var GIFT_CANCEL_REQUEST = 'GIFT_CANCEL_REQUEST';
exports.GIFT_CANCEL_REQUEST = GIFT_CANCEL_REQUEST;
var GIFT_CANCEL_SUCCESS = 'GIFT_CANCEL_SUCCESS';
exports.GIFT_CANCEL_SUCCESS = GIFT_CANCEL_SUCCESS;
var GIFT_CANCEL_FAIL = 'GIFT_CANCEL_FAIL';
exports.GIFT_CANCEL_FAIL = GIFT_CANCEL_FAIL;
var GIFT_SALES_INTEGRATIONS_RESET = 'GIFT_SALES_INTEGRATIONS_RESET';
exports.GIFT_SALES_INTEGRATIONS_RESET = GIFT_SALES_INTEGRATIONS_RESET;
var GIFT_VERIFY_AVAILABLE_CONTACT_REQUEST = 'GIFT_VERIFY_AVAILABLE_CONTACT_REQUEST';
exports.GIFT_VERIFY_AVAILABLE_CONTACT_REQUEST = GIFT_VERIFY_AVAILABLE_CONTACT_REQUEST;
var GIFT_VERIFY_AVAILABLE_CONTACT_SUCCESS = 'GIFT_VERIFY_AVAILABLE_CONTACT_SUCCESS';
exports.GIFT_VERIFY_AVAILABLE_CONTACT_SUCCESS = GIFT_VERIFY_AVAILABLE_CONTACT_SUCCESS;
var GIFT_VERIFY_AVAILABLE_CONTACT_FAILED = 'GIFT_VERIFY_AVAILABLE_CONTACT_FAILED';
exports.GIFT_VERIFY_AVAILABLE_CONTACT_FAILED = GIFT_VERIFY_AVAILABLE_CONTACT_FAILED;
var GIFT_VERIFY_AVAILABLE_CONTACT_RESET = 'GIFT_VERIFY_AVAILABLE_CONTACT_RESET';
exports.GIFT_VERIFY_AVAILABLE_CONTACT_RESET = GIFT_VERIFY_AVAILABLE_CONTACT_RESET;
var GIFT_SET_PRODUCT_OPTIONS_REQUEST = 'GIFT_VERIFY_SET_PRODUCT_OPTIONS_REQUEST';
exports.GIFT_SET_PRODUCT_OPTIONS_REQUEST = GIFT_SET_PRODUCT_OPTIONS_REQUEST;
var GIFT_SET_PRODUCT_OPTIONS_SUCCESS = 'GIFT_VERIFY_SET_PRODUCT_OPTIONS_SUCCESS';
exports.GIFT_SET_PRODUCT_OPTIONS_SUCCESS = GIFT_SET_PRODUCT_OPTIONS_SUCCESS;
var GIFT_SET_PRODUCT_OPTIONS_FAILED = 'GIFT_VERIFY_SET_PRODUCT_OPTIONS_FAILED';
exports.GIFT_SET_PRODUCT_OPTIONS_FAILED = GIFT_SET_PRODUCT_OPTIONS_FAILED;